module.exports = __webpack_public_path__ + "img/GR115.cf8171da.png";